import React, { useState, useEffect } from "react";
import {
  Button,
  FormControl,
  FormLabel,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@material-ui/core";
import useStyles from "../../../../styles";
import axios from "axios";
import { decryptData } from "../../../../crypto";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { ReactComponent as PhoneIcon } from "../../../images/learnersimage/phoneicon.svg";
import { ReactComponent as NameIcon } from "../../../images/learnersimage/nameicon.svg";
import { ReactComponent as EmailIcon } from "../../../images/learnersimage/emailicon.svg";
import { Autocomplete } from "@material-ui/lab";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";

function EditCenterForm() {
  const classes = useStyles();

  const initialData = {
    center_name: "",
    center_code: "",
    phone: "",
    email: "",
    contact_person_name: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
    password: "",
    course_id: "",
    batch_id: "",
  };

  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const navigate = useNavigate();
  const { rowId } = useParams();
  const [centerName, setCenterName] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [formDetails, setFormDetails] = useState(initialData);

  const [selectedState, setSelectedState] = useState("");
  const [selectedStateId, setSelectedStateId] = useState("");
  const [states, setStates] = useState([]);

  const [districts, setDistricts] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedDistrictId, setSelectedDistrictId] = useState("");

  const [passwordError, setPasswordError] = useState(false);
  const [passwordErrorMessage, setPasswordErrorMessage] = useState("");

  const [pincodeError, setPincodeError] = useState(false);
  const [pincodeErrorMessage, setPincodeErrorMessage] = useState("");

  // New state_id for phone number error message
  const [phoneErrorMessage, setPhoneErrorMessage] = useState("");
  // New state_id for phone number error
  const [phoneError, setPhoneError] = useState(false);

  // State for student email error
  const [emailError, setEmailError] = useState(false);

  const [batches, setBatches] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState("");

  const [cources, setCources] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState("");

  // const fetchBatches = async (selectedCource) => {
  //   try {
  //     const decryptedToken = decryptData(sessionStorage.getItem("token"));

  //     const response = await fetch(
  //       `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/batch/by_course_id/${selectedCource}`,

  //       {
  //         method: "GET",
  //         headers: {
  //           Authorization: `Bearer ${decryptedToken}`,
  //           // Add other headers if needed
  //         },
  //       }
  //     );

  //     if (response.ok) {
  //       const data = await response.json();
  //       setBatches(data.batches);
  //     } else {
  //       console.error("Failed to fetch batches data");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching batches data:", error);
  //   }
  // };

  const fetchBatches = async () => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));

      // Ensure selectedCourses is not empty before making the request
      if (selectedCourse.length > 0) {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/batch/by_course_ids/list`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${decryptedToken}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              batch: {
                course_ids: selectedCourse,
              },
            }),
          }
        );

        if (response.ok) {
          const data = await response.json();
          setBatches(data.batches);
        } else {
          console.error("Failed to fetch batches data:", response);
        }
      }
    } catch (error) {
      console.error("Error fetching batches data:", error);
    }
  };

  useEffect(() => {
    if(selectedCourse){
      fetchBatches(selectedCourse);
    }
  }, [selectedCourse]);

  const handleBatchChange = (event, newValue) => {
    setSelectedBatch(newValue.map((batch) => batch.id));
  };

  const fetchCources = async () => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));

      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/course`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
            // Add other headers if needed
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        setCources(data.courses);
      } else {
        console.error("Failed to fetch courses data");
      }
    } catch (error) {
      console.error("Error fetching courses data:", error);
    }
  };

  useEffect(() => {
    fetchCources();
  }, []);

  const handleCourseChange = (event, newValue) => {
    setSelectedCourse(newValue.map((cource) => cource.id));
  };

  const handleToggleShowPassword = () => {
    setShowPassword(!showPassword);
    console.log("Password visibility toggled:", !showPassword); // Debugging
  };

  // Updated phone field handler
  const handlePhoneChange = (value) => {
    const phoneRegex = /^[6789]\d{0,9}$/; // Updated regex to allow only 10 digits

    // Check if the input starts with 6, 7, 8, or 9 and is up to 10 digits long
    if (phoneRegex.test(value) || value === "") {
      setPhoneErrorMessage("");
      setPhoneError(false);
      handleFormChange("phone", value);
    } else {
      if (value.length <= 10) {
        setPhoneErrorMessage("Phone number should start with 6, 7, 8, or 9.");
        setPhoneError(true);
      }
    }
  };

  // Function to validate email
  const validateEmail = (email) => {
    // Standard email regex pattern
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  // Handler for student email field
  const handleEmailChange = (email) => {
    if (!validateEmail(email)) {
      setEmailError(true);
    } else {
      setEmailError(false);
    }
    handleFormChange("email", email); // Assuming your state_id field is named 'studentEmail'
  };

  const handleClose = () => {
    navigate("/admin/center");
  };

  const fetchStates = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/admin/state`,
        {
          method: "GET",
        }
      );

      if (response.ok) {
        const data = await response.json();
        setStates(data.states);
      } else {
        console.error("Failed to fetch categories data");
      }
    } catch (error) {
      console.error("Error fetching categories data:", error);
    }
  };
  useEffect(() => {
    fetchStates();
  }, []);

  const fetchDistricts = async (selectedStateId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/admin/state/${selectedStateId}`,
        {
          method: "GET",
        }
      );

      if (response.ok) {
        const data = await response.json();
        setDistricts(data.cities);
      } else {
        console.error("Failed to fetch categories data");
      }
    } catch (error) {
      console.error("Error fetching categories data:", error);
    }
  };
  useEffect(() => {
    if (selectedStateId) {
      fetchDistricts(selectedStateId);
    }
  }, [selectedStateId]);

  const handleStateChange = (event, value) => {
    setSelectedState(value);
    setSelectedStateId(value.id);
  };
  const handleDistrictChange = (event, value) => {
    setSelectedDistrict(value);
    setSelectedDistrictId(value.id);
  };

  const fetchDataFromAPI = async (rowId) => {
    try {
      const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/v1/client/center/${rowId}`;
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      });

      if (response.status === 200) {
        const data = response.data.center;
        const initialData = {
          center_name: data?.center_name ? data.center_name : null,
          center_code: data?.center_code ? data.center_code : null,
          phone: data?.phone ? data.phone : null,
          email: data?.email ? data.email : null,
          contact_person_name: data?.contact_person_name
            ? data.contact_person_name
            : null,
          address: data?.address ? data.address : null,
          state_id: data?.state ? data.state : null,
          district_id: data?.city ? data.city : null,
          pincode: data?.pincode ? data.pincode : null,
          password: data?.password ? data.password : null,
        };
        setFormDetails(initialData);

        setCenterName(data?.center_name);
        setSelectedDistrict(data?.city);
        setSelectedState(data?.state);
        setSelectedDistrictId(data?.city?.id);
        setSelectedStateId(data?.state?.id);
        setSelectedBatch(data?.batch_id);
        setSelectedCourse(data?.course_id);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error fetching data from the API:", error);
    }
  };
  useEffect(() => {
    if (rowId) {
      fetchDataFromAPI(rowId);
    }
  }, [rowId]);
  const handleFormSubmit = async () => {
    // Reset password error state before validation
    setPasswordError(false);
    setPasswordErrorMessage("");
    console.log("emailErroredit", emailError);

    if (
      !centerName.trim() ||
      !formDetails?.center_code?.trim() ||
      !formDetails?.contact_person_name?.trim() ||
      !formDetails?.phone?.trim() ||
      emailError ||
      !formDetails?.password?.trim() ||
      (typeof selectedCourse === "string" && !selectedCourse.trim()) ||
      (typeof selectedBatch === "string" && !selectedBatch.trim()) ||
      (typeof selectedStateId === "string" && !selectedStateId.trim()) ||
      (typeof selectedDistrictId === "string" && !selectedDistrictId.trim())
    ) {
      if (!centerName.trim()) {
        toast.warn("Please enter a Branch name.");
      } else if (!formDetails?.center_code?.trim()) {
        toast.warn("Please enter Branch code.");
      } else if (!formDetails?.contact_person_name?.trim()) {
        toast.warn("Please enter contact person name.");
      } else if (!formDetails?.phone?.trim()) {
        toast.warn("Please enter a phone number.");
      } else if (emailError) {
        toast.warn("Please enter a valid email address");
      } else if (!formDetails?.email?.trim()) {
        toast.warn("Please enter xcvfd an email.");
      } else if (!formDetails?.password?.trim()) {
        toast.warn("Please enter a password.");
      } else if (typeof selectedCourse === "string" && !selectedCourse.trim()) {
        toast.warn("Please select a course.");
      } else if (typeof selectedBatch === "string" && !selectedBatch.trim()) {
        toast.warn("Please select a batch.");
      } else if (
        typeof selectedStateId === "string" &&
        !selectedStateId.trim()
      ) {
        toast.warn("Please select a state.");
      } else if (
        typeof selectedDistrictId === "string" &&
        !selectedDistrictId.trim()
      ) {
        toast.warn("Please select a city.");
      }

      return;
    }

    if (!formDetails || !formDetails.password || !formDetails.password.trim()) {
      setPasswordError(true);
      setPasswordErrorMessage("Please enter a password.");
      toast.warn("Please enter a password.");
      return; // Prevent form submission
    }

    if (formDetails.password.trim().length < 6) {
      setPasswordError(true);
      setPasswordErrorMessage("Password must be at least 6 characters long");
      toast.warn("Password must be at least 6 characters long");
      return; // Prevent form submission
    }

    const data = {
      center: {
        id: rowId,
        center_name: centerName,
        center_code: formDetails.center_code,
        phone: formDetails.phone,
        email: formDetails.email,
        contact_person_name: formDetails.contact_person_name,
        address: formDetails.address ? formDetails.address : null,
        state: selectedStateId ? selectedStateId : null,
        city: selectedDistrictId ? selectedDistrictId : null,
        pincode: formDetails.pincode ? formDetails.pincode : null,
        password: formDetails.password,
        course_id: selectedCourse,
        batch_id: selectedBatch,
      },
    };

    axios
      .put(`${process.env.REACT_APP_API_BASE_URL}/v1/client/center`, data, {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      })
      .then((response) => {
        toast.success("Branch updated successfully!", response);
        setTimeout(() => {
          navigate("/admin/center");
        }, 2000);
      })
      .catch((error) => {
        toast.error(error.response.data.error);
      });
  };

  const handleFormChange = (fieldName, value) => {
    if (fieldName === "pincode") {
      if (value.length === 6) {
        setPincodeError(false);
        setPincodeErrorMessage("");
      } else {
        setPincodeError(true);
        setPincodeErrorMessage("Pincode must be exactly 6 digits");
      }
      // Update the pincode value only if it's 6 digits or less
      if (value.length <= 6) {
        setFormDetails((prevFormDetails) => ({
          ...prevFormDetails,
          [fieldName]: value,
        }));
      }
    } else {
      setFormDetails((prevFormDetails) => ({
        ...prevFormDetails,
        [fieldName]: value,
      }));
    }
  };
  return (
    <>
      <ToastContainer />

      <div
        className={`${classes.mt1} ${classes.mt1} ${classes.inputpadding} ${classes.inputborder} ${classes.pagescroll} ${classes.h72vh}`}
      >
        <FormControl className={`${classes.w100}`}>
          <div
            className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5} ${classes.mt1}`}
          >
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >
                Branch Details
              </Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Branch Name <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  onChange={(e) => setCenterName(e.target.value)}
                  value={centerName}
                  type="text"
                  variant="outlined"
                  required
                  placeholder="Enter Subject Name"
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal}
             ${classes.fw400} ${classes.lineheight}`}
                >
                  Branch Code <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  onChange={(e) =>
                    handleFormChange("center_code", e.target.value)
                  }
                  value={formDetails.center_code}
                  type="text"
                  variant="outlined"
                  required
                  placeholder="Enter Branch Code"
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Contact Person Name{" "}
                  <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  onChange={(e) =>
                    handleFormChange("contact_person_name", e.target.value)
                  }
                  value={formDetails.contact_person_name}
                  type="text"
                  variant="outlined"
                  required
                  placeholder="Enter Contact Person Name"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <NameIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </div>

            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal}
             ${classes.fw400} ${classes.lineheight}`}
                >
                  Mobile No. <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  onChange={(e) => handlePhoneChange(e.target.value)}
                  value={formDetails.phone}
                  type="text"
                  variant="outlined"
                  required
                  placeholder="91XXXXXXXX"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <PhoneIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                {/* Display error message for phone */}
                {phoneError && (
                  <Typography color="error" className={classes.errorMessage}>
                    {phoneErrorMessage}
                  </Typography>
                )}
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
            ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Email Address <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  onChange={(e) => handleEmailChange(e.target.value)}
                  value={formDetails.email}
                  type="email"
                  variant="outlined"
                  required
                  placeholder="Enter Email Address"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <EmailIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                {/* Display error message for student email */}
                {emailError && (
                  <Typography color="error" className={classes.errorMessage}>
                    Please enter a valid email address
                  </Typography>
                )}
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Create Password{" "}
                  <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  onChange={(e) => handleFormChange("password", e.target.value)}
                  value={formDetails.password}
                  name="password"
                  type={showPassword ? "text" : "password"}
                  variant="outlined"
                  required
                  placeholder="********"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleToggleShowPassword}
                          edge="end"
                        >
                          {showPassword ? (
                            <VisibilityOffIcon />
                          ) : (
                            <VisibilityIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </div>

            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Course <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Autocomplete
                  multiple
                  id="tags-standard"
                  options={cources}
                  getOptionLabel={(option) => option.course_name}
                  value={cources.filter((cou) =>
                    selectedCourse.includes(cou.id)
                  )}
                  onChange={handleCourseChange}
                  disableClearable
                  forcePopupIcon={false}
                  renderInput={(params) => (
                    <TextField
                      name="section"
                      type="text"
                      variant="outlined"
                      placeholder="Type to pick Course..."
                      {...params}
                    />
                  )}
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Batch <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Autocomplete
                  multiple
                  id="tags-standard"
                  options={batches}
                  getOptionLabel={(option) => option.batch_name}
                  value={batches.filter((bat) =>
                    selectedBatch.includes(bat.id)
                  )}
                  onChange={handleBatchChange}
                  disableClearable
                  forcePopupIcon={false}
                  renderInput={(params) => (
                    <TextField
                      name="section"
                      type="text"
                      variant="outlined"
                      placeholder="Type to pick Batch..."
                      {...params}
                    />
                  )}
                />
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              ></div>
            </div>

            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >
                Address
              </Typography>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w74} `}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1}
               ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Address
                </FormLabel>
                <TextField
                  value={formDetails.address}
                  onChange={(e) => handleFormChange("address", e.target.value)}
                  type="text"
                  variant="outlined"
                  required
                  placeholder="Type Here"
                  multiline
                  rows={6}
                />
              </div>
            </div>
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
            ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  State <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Autocomplete
                  id="state-autocomplete"
                  options={states || []}
                  value={selectedState}
                  onChange={handleStateChange}
                  disableClearable
                  getOptionLabel={(option) => option.name}
                  autoHighlight
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select State"
                      variant="outlined"
                      {...params}
                    />
                  )}
                  selectOnFocus
                  openOnFocus
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  City <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Autocomplete
                  id="district_id"
                  options={districts || []}
                  value={selectedDistrict}
                  onChange={handleDistrictChange}
                  disableClearable
                  getOptionLabel={(option) => option.name}
                  autoHighlight
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select City"
                      variant="outlined"
                      {...params}
                    />
                  )}
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
            ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Pincode
                </FormLabel>
                <TextField
                  value={formDetails.pincode}
                  onChange={(e) => handleFormChange("pincode", e.target.value)}
                  name="pincode"
                  type="text"
                  variant="outlined"
                  required
                  placeholder="Enter Pincode"
                  error={pincodeError}
                  helperText={pincodeError ? pincodeErrorMessage : ""}
                  inputProps={{ maxLength: 6, pattern: "\\d*" }}
                />
              </div>
            </div>
          </div>
          <div
            className={`${classes.dflex} ${classes.justifyflexend} ${classes.mt1}`}
          >
            <Button
              className={`${classes.custombtnoutline}`}
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              onClick={handleFormSubmit}
              className={`${classes.custombtnblue}`}
            >
              Submit
            </Button>
          </div>
        </FormControl>
      </div>
    </>
  );
}
export default EditCenterForm;
